/* nylstudios theme — interactions */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var NYL = window.NYL || { routes: { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', search: '/search/suggest', root: '/' }, moneyFormat: 'LE {{amount}}' };

  function money(cents) {
    var fmt = NYL.moneyFormat || '{{amount}}';
    var n = (cents / 100);
    var two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var none = Math.round(n).toLocaleString('en-US');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return none;
      if (k === 'amount_with_comma_separator') return two.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1');
      return two;
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- overlays ---------- */
  var scrim = $('#scrim');
  var lastFocus = null;
  function openPanel(id) {
    closeAll(true);
    var el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('on'); if (scrim) scrim.classList.add('on'); });
    var f = el.querySelector('input[type=search],input:not([type=hidden]),button,a[href]');
    if (f) setTimeout(function () { f.focus(); }, 80);
    document.documentElement.style.overflow = 'hidden';
  }
  function closeAll(quick) {
    var any = false;
    $$('.drawer.on,.search.on').forEach(function (el) {
      any = true;
      el.classList.remove('on');
      setTimeout(function () { if (!el.classList.contains('on')) el.hidden = true; }, quick ? 0 : 260);
    });
    if (scrim) scrim.classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(resetMenu, 280);
    if (any && !quick && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (scrim) scrim.addEventListener('click', function () { closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-close]'); if (c) { e.preventDefault(); closeAll(); return; }
  });
  var menuBtn = $('#menuBtn'), searchBtn = $('#searchBtn'), cartBtn = $('#cartBtn');
  if (menuBtn) menuBtn.addEventListener('click', function () { openPanel('menu'); });
  if (searchBtn) searchBtn.addEventListener('click', function () { openPanel('search'); });
  if (cartBtn) cartBtn.addEventListener('click', function (e) {
    if (document.body.classList.contains('t-cart')) return; // on /cart, follow the link
    e.preventDefault(); openPanel('cart');
  });

  /* ---------- menu sub-panels ---------- */
  var mroot = $('#mroot');
  function resetMenu() { if (!mroot) return; mroot.classList.remove('out'); $$('.mpane.sub').forEach(function (p) { p.classList.remove('on'); }); }
  $$('[data-sub]').forEach(function (b) {
    b.addEventListener('click', function () { mroot.classList.add('out'); var p = $('#msub-' + b.dataset.sub); if (p) p.classList.add('on'); });
  });
  $$('[data-back]').forEach(function (b) { b.addEventListener('click', resetMenu); });

  /* ---------- header over hero ---------- */
  var hdr = $('#hdr'), hero = $('#hero');
  function hdrState() {
    if (!hdr) return;
    var over = hdr.dataset.over === 'true' && hero && window.scrollY < (hero.offsetHeight - 90);
    hdr.classList.toggle('over', !!over);
  }
  window.addEventListener('scroll', hdrState, { passive: true });
  window.addEventListener('resize', hdrState);
  hdrState();

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach(function (box) {
    var t = Date.parse(box.dataset.countdown);
    if (isNaN(t)) { box.hidden = true; return; }
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var ms = t - Date.now();
      if (ms <= 0) { box.hidden = true; return false; }
      var m = Math.floor(ms / 60000);
      box.querySelector('[data-cd=d]').textContent = pad(Math.floor(m / 1440));
      box.querySelector('[data-cd=h]').textContent = pad(Math.floor(m % 1440 / 60));
      box.querySelector('[data-cd=m]').textContent = pad(m % 60);
      return true;
    }
    if (tick()) var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 15000);
  });

  /* ---------- predictive search ---------- */
  var q = $('#q'), pres = $('#pres'), sbase = $('#sbase'), st;
  if (q && pres) {
    q.addEventListener('input', function () {
      clearTimeout(st);
      var v = q.value.trim();
      if (!v) { pres.hidden = true; pres.innerHTML = ''; if (sbase) sbase.hidden = false; return; }
      st = setTimeout(function () {
        fetch(NYL.routes.search + '?q=' + encodeURIComponent(v) + '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var d = new DOMParser().parseFromString(html, 'text/html');
            var s = d.querySelector('.shopify-section') || d.body;
            pres.innerHTML = s.innerHTML; pres.hidden = false; if (sbase) sbase.hidden = true;
          }).catch(function () {});
      }, 180);
    });
  }

  /* ---------- cart drawer ---------- */
  function setCount(n) {
    var b = $('#badge'); if (b) { b.textContent = n; b.dataset.n = n; }
    if (cartBtn) cartBtn.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
  }
  function swapDrawer(html, keepOpen) {
    if (!html) return;
    var d = new DOMParser().parseFromString(html, 'text/html');
    var fresh = d.querySelector('#cart'), cur = $('#cart');
    if (!fresh || !cur) return;
    if (keepOpen) { fresh.hidden = false; fresh.classList.add('on'); }
    cur.replaceWith(fresh);
    setCount(parseInt(fresh.dataset.count || '0', 10));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#cart [data-qty]'); if (!b) return;
    e.preventDefault();
    var line = b.closest('[data-line]'); if (!line) return;
    var cart = $('#cart'); cart.classList.add('loading');
    fetch(NYL.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: parseInt(b.dataset.qty, 10), sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (data) { swapDrawer(data.sections && data.sections['cart-drawer'], true); })
      .catch(function () { window.location.href = NYL.routes.cart; })
      .finally(function () { var c = $('#cart'); if (c) c.classList.remove('loading'); });
  });

  /* ---------- product ---------- */
  var pj = $('#productJson'), form = $('#pform');
  if (pj && form) {
    var product = JSON.parse(pj.textContent);
    var groups = $$('[data-option]', form);
    var chosen = product.options.map(function () { return null; });
    var addBtn = $('#addBtn'), mbarBtn = $('#mbarBtn'), hint = $('#sizeHint'), msg = $('#formMsg');
    var idInput = $('[data-variant-id]', form);
    var initial = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    groups.forEach(function (g) {
      var i = parseInt(g.dataset.option, 10);
      var btns = $$('button', g);
      var required = g.hasAttribute('data-required') && btns.length > 1;
      if (!required) chosen[i] = initial.options[i];
      btns.forEach(function (b) {
        var on = chosen[i] === b.dataset.value;
        b.setAttribute('aria-pressed', on); if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', on);
        b.addEventListener('click', function () {
          if (b.disabled) return;
          chosen[i] = b.dataset.value;
          btns.forEach(function (x) { var o = x === b; x.setAttribute('aria-pressed', o); if (x.getAttribute('role') === 'radio') x.setAttribute('aria-checked', o); });
          var lab = $('[data-opt-label="' + i + '"]'); if (lab) lab.textContent = b.dataset.value;
          if (hint) { hint.classList.remove('err'); hint.textContent = hint.dataset.default || ''; }
          update(true);
        });
      });
    });

    function match() {
      if (chosen.some(function (c) { return c === null; })) return null;
      return product.variants.find(function (v) { return v.options.every(function (o, k) { return o === chosen[k]; }); }) || null;
    }
    function markAvailability() {
      // for each option value, cross it out if no available variant matches it with the other chosen values
      groups.forEach(function (g) {
        var i = parseInt(g.dataset.option, 10);
        $$('button', g).forEach(function (b) {
          var ok = product.variants.some(function (v) {
            return v.available && v.options[i] === b.dataset.value && v.options.every(function (o, k) { return k === i || chosen[k] === null || chosen[k] === o; });
          });
          if (g.classList.contains('sizes')) { b.disabled = !ok; b.setAttribute('aria-disabled', !ok); }
          b.title = ok ? '' : 'Sold out';
        });
      });
    }
    function update(fromUser) {
      markAvailability();
      var v = match();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = addBtn.dataset.labelSelect;
        if (mbarBtn) mbarBtn.textContent = addBtn.dataset.labelSelect;
        return;
      }
      idInput.value = v.id;
      $$('[data-price]').forEach(function (p) { p.textContent = money(v.price); });
      var cmp = $('[data-compare]'); if (cmp) cmp.hidden = !(v.compare_at_price > v.price);
      if (v.available) {
        addBtn.disabled = false; addBtn.textContent = addBtn.dataset.labelAdd + ' — ' + money(v.price);
        if (mbarBtn) mbarBtn.textContent = addBtn.dataset.labelAdd;
      } else {
        addBtn.disabled = true; addBtn.textContent = addBtn.dataset.labelSoldout;
        if (mbarBtn) mbarBtn.textContent = addBtn.dataset.labelSoldout;
      }
      if (fromUser) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
        if (v.featured_media) goToMedia(v.featured_media.id);
      }
    }
    update(false);

    function add() {
      var v = match();
      if (!v) {
        if (hint) { hint.classList.add('err'); hint.textContent = 'Choose a size first.'; }
        var s = $('.sizes', form); if (s) s.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (!v.available) return;
      addBtn.classList.add('loading'); if (msg) msg.hidden = true;
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      fetch(NYL.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (msg) { msg.hidden = false; msg.className = 'formmsg err'; msg.textContent = res.j.description || res.j.message || 'Could not add to cart.'; } return; }
          swapDrawer(res.j.sections && res.j.sections['cart-drawer'], false);
          openPanel('cart');
        })
        .catch(function () { form.submit(); })
        .finally(function () { addBtn.classList.remove('loading'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    if (mbarBtn) mbarBtn.addEventListener('click', add);

    var guide = $('#guideBtn');
    if (guide) guide.addEventListener('click', function () {
      var d = $('details[data-size-guide]'); if (!d) return;
      d.open = true; d.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  /* ---------- gallery ---------- */
  var slides = $('#slides');
  function goToMedia(id) {
    if (!slides) return;
    var all = $$('.slide', slides);
    var i = all.findIndex(function (s) { return s.dataset.mediaId === String(id); });
    if (i > -1) toSlide(i);
  }
  function toSlide(i) { slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); }
  if (slides) {
    var dots = $$('#dots button'), thumbs = $$('.thumbs button'), t;
    var mark = function (i) {
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i); });
      thumbs.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i); });
    };
    slides.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(Math.round(slides.scrollLeft / slides.clientWidth)); }, 60); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { toSlide(i); }); });
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { toSlide(i); }); });
    if (pj) document.body.classList.add('pdp-on');
  }

  /* ---------- policy tabs ---------- */
  var tabs = $$('.tabs [data-tab]');
  function tab(name) {
    var found = tabs.some(function (b) { return b.dataset.tab === name; });
    if (!found) return;
    tabs.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.tab === name); });
    $$('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== name; });
  }
  tabs.forEach(function (b) { b.addEventListener('click', function () { tab(b.dataset.tab); try { history.replaceState(null, '', '#' + b.dataset.tab); } catch (e) {} }); });
  if (tabs.length && location.hash) tab(location.hash.slice(1));
  window.addEventListener('hashchange', function () { if (tabs.length) tab(location.hash.slice(1)); });

  /* ---------- login: recover password toggle ---------- */
  var rec = $('#recover'), log = $('#login');
  function showRecover(on) { if (rec && log) { rec.hidden = !on; log.hidden = on; } }
  $$('[data-toggle-recover]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); showRecover(rec.hidden); }); });
  if (rec && location.hash === '#recover') showRecover(true);
  if (rec && rec.querySelector('.formmsg')) showRecover(true);
})();
;(function(){var bs=document.querySelectorAll('[data-countdown]');for(var i=0;i<bs.length;i++){(function(box){var t=Date.parse(box.getAttribute('data-countdown'));if(isNaN(t))return;if(!box.querySelector('[data-cd=s]')){var d=document.createElement('div');d.innerHTML='<b data-cd=s>--</b>Seconds';box.appendChild(d);}box.removeAttribute('aria-live');function p(n){return String(n).padStart(2,'0');}function k(){var ms=t-Date.now();if(ms<=0){box.hidden=true;return;}var s=Math.floor(ms/1000);box.querySelector('[data-cd=d]').textContent=p(Math.floor(s/86400));box.querySelector('[data-cd=h]').textContent=p(Math.floor(s%86400/3600));box.querySelector('[data-cd=m]').textContent=p(Math.floor(s%3600/60));box.querySelector('[data-cd=s]').textContent=p(s%60);}k();setInterval(k,1000);})(bs[i]);}})();